import Head from "next/head";
import packageJson from '../../package.json';

export default function Home() {
  return (
    <>
      <Head>
        <title>Disputes</title>
        <meta name="description" content="" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {/*
        <link rel="icon" href="/favicon.ico" />
        */}
      </Head>
      <p data-version={packageJson.version}>Welcome to Disputes.</p>
    </>
  );
}
